import React from 'react';
import { Formik, Form } from 'formik';
import { Box, Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { TeamSize, TEAM_SIZE_OPTIONS } from '../../types/partner';

interface TeamSizeFormProps {
  onSubmit: (values: { teamSize: TeamSize }) => void;
  onBack: () => void;
  initialValues: {
    teamSize: TeamSize;
  };
}

const TeamSizeForm: React.FC<TeamSizeFormProps> = ({ onSubmit, onBack, initialValues }) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, handleChange }) => (
        <Form>
          <FormControl fullWidth>
            <InputLabel>Quy mô đội ngũ</InputLabel>
            <Select
              name="teamSize"
              value={values.teamSize}
              onChange={handleChange}
              label="Quy mô đội ngũ"
            >
              {TEAM_SIZE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button onClick={onBack}>Quay lại</Button>
            <Button type="submit" variant="contained" color="primary">
              Tiếp tục
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default TeamSizeForm; 